import styled from 'styled-components';
import { theme } from '@/styles/index';

export const Container = styled.div`
  background-color: #f4f4f4;
  margin-bottom: 20px;
  max-width: 1030px;
  max-height: 400px;
  display: flex;
  flex-direction: column;
  width: fit-content;
  margin: 50px 0px 5px 10px;
  @media (max-width: ${theme.breakpoint.medium}) {
    padding: 12px;
    margin-top: 10px;
  }
`;

export const Link = styled.a`
  color: #e60000;
`;
export const InfoContainer = styled.div`
  width: 100%;
  margin-top: 40px;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  margin-bottom: 30px;
  @media (max-width: ${theme.breakpoint.medium}) {
    flex-direction: row;
    margin-top: 0px;
  }
`;

export const IconContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  @media (max-width: ${theme.breakpoint.medium}) {
    margin-right: 2px;
  }
`;

export const TextContainer = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  @media (max-width: ${theme.breakpoint.medium}) {
    margin: 0px;
  }
`;
